"use client"

import React, { useState, useEffect } from "react";
import { db } from "../Firebase/firebase-config";
import { ref, onValue, update } from "firebase/database";
import { FaInfoCircle } from "react-icons/fa";
import { useAccount } from "../context/AccountContext";
import "./NewOffers.css";

function NewOffers() {
  const { currentAccount, accountSwitchTrigger } = useAccount();
  const [offers, setOffers] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  // Fetch offers in real-time
  useEffect(() => {
    if (!currentAccount) {
      setOffers([]);
      setLoading(false);
      return;
    }

    if (!navigator.onLine) {
      setError("You are offline. Please check your internet connection.");
      setLoading(false);
      return;
    }

    setLoading(true);
    setError("");

    const offersRef = ref(db, "offers");

    const unsubscribe = onValue(
      offersRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          let fetchedOffers = [];

          Object.keys(data).forEach((brand) => {
            Object.keys(data[brand]).forEach((offerId) => {
              fetchedOffers.push({
                id: offerId,
                brand,
                ...data[brand][offerId],
              });
            });
          });

          // Sort newest first by timestamp
          fetchedOffers.sort((a, b) => {
            const timeA = a.timestamp ? new Date(a.timestamp).getTime() : 0;
            const timeB = b.timestamp ? new Date(b.timestamp).getTime() : 0;
            return timeB - timeA;
          });

          setOffers(fetchedOffers);
        } else {
          setOffers([]);
        }
        setLoading(false);
      },
      (err) => {
        setError("Failed to load offers: " + err.message);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [currentAccount, accountSwitchTrigger]);

  // Mark all offers as viewed for this account
  useEffect(() => {
    if (!currentAccount) return;

    const markAsViewed = () => {
      const offersRef = ref(db, "offers");

      onValue(
        offersRef,
        (snapshot) => {
          if (snapshot.exists()) {
            const updates = {};
            const data = snapshot.val();

            Object.keys(data).forEach((brand) => {
              Object.keys(data[brand]).forEach((offerId) => {
                const key = `${brand}-${offerId}`;
                updates[`user_viewed_offers/${currentAccount.uid}/${key}`] = true;
              });
            });

            update(ref(db), updates).catch((err) =>
              console.error("Error marking offers as viewed:", err)
            );
          }
        },
        { onlyOnce: true }
      );
    };

    markAsViewed();
  }, [currentAccount, accountSwitchTrigger]);

  const offerInfo = () => {
    alert(
      "This section displays new offers sent by the supplier based on your interest. Each offer includes brand details, price, discounts, and validity. Review the offer carefully and take necessary action—accept, negotiate, or ignore—before the offer expires."
    );
  };

  if (!currentAccount) {
    return (
      <p className="text-center mt-5 text-danger fw-bold">
        Please login or select an account to view offers.
      </p>
    );
  }

  if (error) {
    return (
      <p className="text-center mt-5 text-danger fw-bold">{error}</p>
    );
  }

  if (loading) {
    return <p className="text-center mt-5 fw-semibold">Loading offers...</p>;
  }

  return (
    <div className="container-fluid new-offer-cont">
      <div className="new-offers-container">
        <h2 className="newoffer-Text">
          New Offers{" "}
          <FaInfoCircle onClick={offerInfo} className="info-Icon" />
        </h2>

        <div className="offers-list">
          {offers.length > 0 ? (
            offers.map((offer) => (
              <div key={offer.id} className="offer-card">
                <h4>
                  {offer.title} - <span className="brand">{offer.brand}</span>
                </h4>
                <p className="offer-des">{offer.description}</p>
                <h6>
                  <strong>Price:</strong> {offer.price}
                </h6>
                <h6>
                  <strong>Validity:</strong> {offer.validity}
                </h6>
              </div>
            ))
          ) : (
            <p className="no-offers">No offers available at the moment.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default NewOffers;
